import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"

import PropTypes from "prop-types"

import "../../../node_modules/swiper/swiper.scss"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const TimeLine = props => {
  return (
    <div className="hori-timeline">
      <Swiper
        slidesPerView={props.slidesperview}
        spaceBetween={props.spacebetween}
        navigation={props.navigation}
        loop={props.loop}
        pagination={props.pagination}
        breakpoints={props.breakpoints}
        modules={props.modules}
        className={props.className}
        scrollbar={{ draggable: true }}
      >
        {props.children &&
          props.children.map((element, index) => {
            const disabled = element.description
              ? "text-primary"
              : "text-disable"
            return (
              <SwiperSlide
                className={
                  "item event-list" + (element.active ? " active" : "")
                }
                style={{ display: "inline-table", paddingBottom: 30 }}
                key={index}
              >
                <div>
                  <div className="event-down-icon">
                    {element.icon && (
                      <FontAwesomeIcon
                        icon={element.icon}
                        className={`bx ${element.icon} h1 ${disabled} down-arrow-icon`}
                      />
                    )}
                  </div>
                  <div className="event-date">
                    <h5 className={`${element.subclass} mb-1`}>
                      {element.title}
                    </h5>
                    {element.subTitle && (
                      <h6 className="mb-4">{element.subTitle}</h6>
                    )}
                  </div>

                  {element.description && (
                    <div className="mt-3 px-3">
                      <p className="text-muted">{element.description}</p>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            )
          })}
      </Swiper>
    </div>
  )
}

TimeLine.propTypes = {
  slidesperview: PropTypes.number.isRequired,
  spacebetween: PropTypes.number,
  navigation: PropTypes.any,
  loop: PropTypes.bool,
  pagination: PropTypes.object,
  breakpoints: PropTypes.object,
  modules: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.any,
}

export default TimeLine
